var unitPrice = "{{ pricePerUnit }} cada";
var unitsCount = "{{ unitsCount }} unidades";
var unitCount = "{{ unitsCount }} unidade";
var unitPriceWithQuantity = "{{ pricePerUnit }} cada / {{ unitsCount }} unidades";
var vatInclusive = "Com IVA";
var vatExclusive = "Sem IVA";
var excludeShipping = "Sem {{ shipping }}";
var includeShipping = "Com {{ shipping }}";
var shipping = "envio";
var vatAndShipping = {
	includeVatExcludeShipping: "Com IVA, sem {{ shipping }}",
	excludeVatIncludeShipping: "Sem IVA, com {{ shipping }}",
	includeVatIncludeShipping: "Com IVA, com {{ shipping }}",
	excludeVatExcludeShipping: "Sem IVA, sem {{ shipping }}"
};
var priceSummary = "Resumo do preço";
var priceSummaryInfoIcon = "Ícone de informações de resumo do preço";
var priceSummaryModal = "Caixa de diálogo de resumo do preço";
var priceSummaryCloseModal = "Fechar caixa de diálogo de resumo do preço";
var priceSummaryTermsAndConditions = "*Para cada encomenda, é criada uma tela ou almofada única e o equipamento é ajustado para imprimir o seu design. ";
var priceSummaryBasePrice = "Preço base";
var priceSummarySetupFee = "Taxa de configuração*";
var priceSummarySubtotal = "Subtotal";
var differentialPrice = {
	included: "Incluído",
	forUnits: "{{ differentialPrice }} por {{ quantity }} unidades",
	forUnit: "{{ differentialPrice }} por {{ quantity }} unidade"
};
var priceFrom = "A partir de {{ price }}";
var priceFromEach = "A partir de {{ price }} cada";
var volumeDiscount = "{{volumeDiscount}}% de desconto de volume";
var volumeDiscountPlusSale = "{{volumeDiscount}}% de desconto de volume + promoção";
var rangePrice = "{{xx}} - {{yy}}";
var unitRangePrice = "{{rangePrice}} cada";
var originalPrice = "preço original:";
var salePrice = "preço promocional atual:";
var setupFee = "Taxa de configuração ({{ setupFee }}) aplicável";
var noSetupFee = "Sem taxa de configuração";
var vatAndSetupFee = {
	noVatInclSetup: "Taxa de configuração ({{ setupFee }}) incluída",
	inclVatAndSetup: "Taxa de configuração ({{ setupFee }}) e IVA incluídos",
	exclVatInclSetup: "Taxa de configuração ({{ setupFee }}) incluída, sem IVA",
	inclVatSetupInclShipping: "Taxa de configuração ({{ setupFee }}) e IVA incluídos, {{ shipping }} incluído",
	inclVatSetupExclShipping: "Taxa de configuração ({{ setupFee }}) e IVA incluídos, sem {{ shipping }}",
	exclVatSetupInclShipping: "Taxa de configuração ({{ setupFee }}) incluída, sem IVA, {{ shipping }} incluído",
	exclVatSetupExclShipping: "Taxa de configuração ({{ setupFee }}) incluída, sem IVA e {{ shipping }}"
};
var priceFor = "{{ quantity }} por {{ price }}";
var ptpt = {
	unitPrice: unitPrice,
	unitsCount: unitsCount,
	unitCount: unitCount,
	unitPriceWithQuantity: unitPriceWithQuantity,
	vatInclusive: vatInclusive,
	vatExclusive: vatExclusive,
	excludeShipping: excludeShipping,
	includeShipping: includeShipping,
	shipping: shipping,
	vatAndShipping: vatAndShipping,
	priceSummary: priceSummary,
	priceSummaryInfoIcon: priceSummaryInfoIcon,
	priceSummaryModal: priceSummaryModal,
	priceSummaryCloseModal: priceSummaryCloseModal,
	priceSummaryTermsAndConditions: priceSummaryTermsAndConditions,
	priceSummaryBasePrice: priceSummaryBasePrice,
	priceSummarySetupFee: priceSummarySetupFee,
	priceSummarySubtotal: priceSummarySubtotal,
	differentialPrice: differentialPrice,
	priceFrom: priceFrom,
	priceFromEach: priceFromEach,
	volumeDiscount: volumeDiscount,
	volumeDiscountPlusSale: volumeDiscountPlusSale,
	rangePrice: rangePrice,
	unitRangePrice: unitRangePrice,
	originalPrice: originalPrice,
	salePrice: salePrice,
	setupFee: setupFee,
	noSetupFee: noSetupFee,
	vatAndSetupFee: vatAndSetupFee,
	priceFor: priceFor
};

export { ptpt as default, differentialPrice, excludeShipping, includeShipping, noSetupFee, originalPrice, priceFor, priceFrom, priceFromEach, priceSummary, priceSummaryBasePrice, priceSummaryCloseModal, priceSummaryInfoIcon, priceSummaryModal, priceSummarySetupFee, priceSummarySubtotal, priceSummaryTermsAndConditions, rangePrice, salePrice, setupFee, shipping, unitCount, unitPrice, unitPriceWithQuantity, unitRangePrice, unitsCount, vatAndSetupFee, vatAndShipping, vatExclusive, vatInclusive, volumeDiscount, volumeDiscountPlusSale };
